import { createSelector } from "@ngrx/store";

import * as fromFeature from "../reducers";
import * as fromSelectedStudents from "../reducers/selected-students.reducer";

export const getSelectedAssignStudentsState = createSelector(
    fromFeature.getAssignModuleState,
    (state: fromFeature.AssignState) => state.selectedStudents
);

export const getSelectedAssignStudents = createSelector(
    getSelectedAssignStudentsState,
    fromSelectedStudents.getSelectedAssignStudents
);

export const getAssignWorking = createSelector(
    getSelectedAssignStudentsState,
    fromSelectedStudents.getAssignWorking
);
